export enum VideoSettingsFileType {
  MP4 = 'mp4',
  WEBM = 'webm',
}

export enum VideoSettingsColorSpace {
  Empty = 'Empty',
  YUV = 'yuv422p',
}

export enum VideoSettingsColorSpaceValue {
  Empty = 0,
  YUV = 1,
}

export enum VideoSettingsAAL {
  Empty = 'Empty',
  AAL24LUF = '-24 LUF',
  AAL23LUF = '-23 LUF',
  AAL22LUF = '-22 LUF',
  AAL21LUF = '-21 LUF',
  AAL20LUF = '-20 LUF',
}

export enum VideoSettingsAALValue {
  Empty = 0,
  AAL24LUF = -24,
  AAL23LUF = -23,
  AAL22LUF = -22,
  AAL21LUF = -21,
  AAL20LUF = -20,
}

export enum VideoSettingsAMP {
  Empty = 'Empty',
  _2AMP = '-2 dBFS',
  _6AMP = '-6 dBFS',
}

export enum VideoSettingsAMPValue {
  Empty = 0,
  _2AMP = -2,
  _6AMP = -6,
}

export enum VideoSettingsABR {
  Empty = 'Empty',
  _96ABR = '96 kbps',
  _192ABR = '192 kbps',
  _256ABR = '256 kbps',
  _320ABR = '320 kbps',
}

export enum VideoSettingsABRValue {
  Empty = 0,
  _96ABR = 96,
  _192ABR = 192,
  _256ABR = 256,
  _320ABR = 320,
}
